module.exports = __webpack_public_path__ + "static/img/h2.481bfe1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/h2.gif
// module id = 1PBk
// module chunks = 1